// Body-camera recordings of every entry (doc 20.2): visible only to the account holder and people they allow.
import { api } from "../lib/api";
import { brand } from "../lib/brand";
import { fmt, t } from "../lib/i18n";
import { h, resource } from "../lib/ui";
import { Async, Dialog, openDialog } from "../shared/components";
import { Icon } from "../shared/icons";

function play(v: any) {
  openDialog((close) => (
    <Dialog title={t("customer.videos.playerTitle", { date: fmt.dateTime(v.recorded_start ?? v.created_at) })} onClose={close} wide>
      <div class="stack">
        <video src={`/api/my/videos/${v.id}/stream`} controls playsInline preload="metadata" style="width:100%;border-radius:14px;background:#000" />
        <div class="row between">
          <span class="small muted">{t("customer.videos.expires", { date: fmt.date(v.expires_at) })}</span>
          <a class="btn secondary small" href={`/api/my/videos/${v.id}/stream?download=1`} download><Icon name="download" size={16} />{t("customer.videos.download")}</a>
        </div>
      </div>
    </Dialog>
  ));
}

export function VideosPage(props: { homeId: string }) {
  const r = resource(`my.videos.${props.homeId}`, () => api.get(`/api/my/homes/${props.homeId}/videos`));
  return (
    <div class="stack loose">
      <div class="stack tight">
        <h1>{t("customer.videos.heading")}</h1>
        <p class="muted small">{t("customer.videos.intro", { app: brand.current.appName })}</p>
      </div>
      {Async(r, (rows: any[]) => rows.length ? (
        <div class="list">
          {rows.map((v) => {
            const mins = v.recorded_start && v.recorded_end ? Math.max(1, Math.round((+new Date(v.recorded_end) - +new Date(v.recorded_start)) / 60000)) : null;
            return (
              <button class="list-row" onClick={() => play(v)}>
                <Icon name="video" />
                <div class="grow stack tight" style="gap:0">
                  <span class="strong">{v.visit_type ? t(`visitType.${v.visit_type}`) : t("customer.videos.entry")} · {fmt.date(v.recorded_start ?? v.created_at, "short")}</span>
                  <span class="small muted">{[v.expert, mins ? t("customer.videos.minutes", { count: mins }) : null, fmt.bytes(Number(v.size))].filter(Boolean).join(" · ")}</span>
                </div>
                <span class="xs muted nowrap">{t("customer.videos.daysLeft", { count: Math.max(0, Math.ceil((+new Date(v.expires_at) - Date.now()) / 86400000)) })}</span>
              </button>
            );
          })}
        </div>
      ) : (
        <div class="list"><div class="empty"><strong>{t("customer.videos.emptyTitle")}</strong><span>{t("customer.videos.emptyBody")}</span></div></div>
      ))}
      <div class="note small"><Icon name="lock" size={16} /> {t("customer.videos.policy", { app: brand.current.appName })}</div>
    </div>
  );
}
